import {
  Component,
  ElementRef,
  Input,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ServiceLocatorService } from '@ncs/ncs-lib';
import { UiformBaseComponent } from '../uiform-base/uiform-base.component';

@Component({
  selector: 'app-uiform-graph',
  templateUrl: './uiform-graph.component.html',
  styleUrls: ['./uiform-graph.component.scss'],
})
export class UiformGraphComponent extends UiformBaseComponent {
  @ViewChild('content')
  content!: ElementRef;

  public target_name = 'chart';

  public loading: boolean = false;

  public cachedChartData: { [key: string]: any } = {}; // Cache to store chart data

  public usecaseSchema: any = {};

  public filteredAttributes: any = [];
  constructor(
    public override locator: ServiceLocatorService,
    public override route: ActivatedRoute
  ) {
    super(locator, route);
    let _self = this;
    if (route.snapshot.paramMap.get('uiformId'))
      _self.uiformId = Number(route.snapshot.paramMap.get('uiformId'));
    if (route.snapshot.paramMap.get('formId')) {
      _self.uiformId = Number(route.snapshot.paramMap.get('formId'));
      _self.target_name = 'chart-custom';
    } else {
      _self.target_name = 'chart';
    }
    _self.locator.config
      .getProperty('endpoint.ui.forms')
      .then((property: string) => {
        _self.initApiEndpoint(property);
      });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['uiformId']) {
      this.ngOnInit(); // Call ngOnInit or relevant method only if uiformId changes
    }
  }

  override ngOnInit() {
    let _self = this;
    _self.locator.config
      .getProperty('endpoint.userstory')
      .then((property: string) => {
        if (_self.uiformId) {
          this.get(_self.uiformId, function () {
            _self.usecaseId = _self.form.data.userstoryId;
            _self.getUsecaseSchema();
          });
        }
      });
  }

  resetSearchValues() {
    this.form.data.field = '';
  }

  public drawChart() {
    let _self = this;
    //_self.loading = true;
    let code = this.form.data.field;
    if (code === undefined || code === '') {
      _self.filteredAttributes = _self.filterFieldsAttributes();
      return;
    }

    setTimeout(() => {
      let fields = _self
        .filterFieldsAttributes()
        .filter((e: any) => e.code === code);
      _self.filteredAttributes = _self.usecaseAttributes.filter(
        (attribute: any) => attribute.code === code && code !== 'undefined'
      );
    }, 100);
  }

  filterFieldsAttributes(): any {
    let _self = this;
    const allowedTypes = ['date', 'list', 'time'];
    let code = this.form.data.field;
    if (code === undefined || code === '') {
      const result = _self.usecaseAttributes.filter(
        (attr: any) =>
          (_self.form.data['fields'].some(
            (field: any) => field.id === attr.id
          ) &&
            allowedTypes.includes(attr['type'])) ||
          _self.parentUsecaseList.some(
            (parentAttr: any) => parentAttr.id === attr.id
          )
      );
      return result;
    }

    //List Filter Search
    const result = _self.usecaseAttributes.filter(
      (attribute: any) => attribute.code === code && code !== 'undefined'
    );
    return result;
  }

  public filterAttributeLabel(): any {
    let _self = this;
    const allowedTypes = ['date', 'time', 'list'];
    const result = _self.usecaseAttributes.filter(
      (attr: any) =>
        (_self.form.data['fields'].some((field: any) => field.id === attr.id) &&
          allowedTypes.includes(attr['type'])) ||
        _self.parentUsecaseList.some(
          (parentAttr: any) => parentAttr.id === attr.id
        )
    );
    return result;
  }

  /**
   * Row and Column Correction in row
   * @param index
   * @returns
   */
  isLastOdd(index: number): boolean {
    return (
      this.filterFieldsAttributes().length % 2 !== 0 &&
      index === this.filterFieldsAttributes().length - 1
    );
  }
}
